import { useTheme } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'

function PromoMessage() {
    const theme = useTheme()
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))

    return (
        <p
            style={{
                textWrap: 'balance',
                marginTop: '0px',
            }}
        >
            Build a personalized gift card with a photo. Printed and shipped{' '}
            {isLgUp && <br />}same-day for orders placed{' '}
            <strong>by 4pm ET (Mon-Fri)</strong>.
        </p>
    )
}
export default PromoMessage
